import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.users');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RU, getAdminT } from "src/libs/portal/korslovo/i18n";

@Component({
    selector: 'wiz-page-admin-users',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.users/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: auto;
}`],
})
export class PageAdminUsersComponent implements OnInit, OnDestroy {
    public ru = RU;
    public t: any = RU;
    public list: any[] = [];
    public loading: boolean = true;
    public searchText: string = '';
    public roleFilter: string = '';
    public page: number = 1;
    public dump: number = 30;
    public total: number = 0;
    public inactiveDays: number = 0;
    private langListener: any;
    private searchTimer: any;
    private loadRequestId: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.t = getAdminT();
        this.langListener = async () => { this.t = getAdminT(); await this.service.render(); };
        window.addEventListener('admin-lang-change', this.langListener);
        await this.load();
    }

    ngOnDestroy() {
        if (this.langListener) window.removeEventListener('admin-lang-change', this.langListener);
        if (this.searchTimer) clearTimeout(this.searchTimer);
        this.loadRequestId += 1;
    }

    public async load() {
        const requestId = ++this.loadRequestId;
        this.loading = true;
        await this.service.render();

        const res: any = await wiz.call("list", {
            text: this.searchText,
            role: this.roleFilter,
            page: this.page,
            dump: this.dump,
            inactive_days: this.inactiveDays
        });
        if (requestId !== this.loadRequestId) return;

        if (res?.code === 200) {
            // Keep compatibility with legacy array and double-wrapped API responses.
            const payload = res.data?.data ?? res.data;
            if (Array.isArray(payload)) {
                this.list = payload;
                this.total = payload.length;
            } else {
                this.list = Array.isArray(payload?.rows) ? payload.rows : [];
                this.total = Number(payload?.total) || 0;
            }
        } else {
            this.list = [];
            this.total = 0;
            if (res?.code === 401) {
                this.service.href('/access');
                return;
            }
        }

        this.loading = false;
        await this.service.render();
    }

    public get totalPages(): number {
        return Math.ceil(this.total / this.dump) || 1;
    }

    public async goPage(p: number) {
        if (p < 1 || p > this.totalPages) return;
        this.page = p;
        await this.load();
    }

    public async onSearch() {
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
            this.searchTimer = null;
        }
        this.page = 1;
        await this.load();
    }

    public onSearchInput() {
        if (this.searchTimer) clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
            this.searchTimer = null;
            this.onSearch();
        }, 250);
    }

    public async onInactiveFilter(days: number) {
        this.inactiveDays = this.inactiveDays === days ? 0 : days;
        this.page = 1;
        await this.load();
    }

    public async changeRole(user: any, newRole: string) {
        if (user.role === newRole) return;
        const { code } = await wiz.call("change_role", { id: user.id, role: newRole });
        if (code === 200) {
            user.role = newRole;
            await this.service.render();
        }
    }

    public goDetail(user: any) {
        this.service.href(`/admin/users/${user.id}`);
    }

    public roleLabel(role: string): string {
        if (role === 'admin') return 'Администратор';
        return 'Пользователь';
    }

    public roleBadge(role: string): string {
        if (role === 'admin') return 'text-purple-700 bg-purple-50 ring-purple-600/20';
        return 'text-blue-700 bg-blue-50 ring-blue-600/20';
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '-';
        try {
            const d = new Date(dateStr);
            return d.toLocaleDateString('ru-RU', { year: 'numeric', month: 'short', day: 'numeric' });
        } catch {
            return dateStr;
        }
    }
}

export default PageAdminUsersComponent;